export default __webpack_public_path__ + "static/media/photo--sm--misc-22.9e54cb7f.jpg";